module.exports = __webpack_public_path__ + "img/terms.cc6e45a2.svg";